import { LRUCache as LRU } from 'lru-cache'

const __cache = new LRU<string, any>({
    max: 30000,
});

export class APICacheInstance {
    public static setValue<T>(key: string, value: T) {
        __cache.set(key, value);
    }

    public static getValue<T>(key: string): T {
        if (!__cache.has(key)) {
            return null;
        }

        return __cache.get(key);
    }

    public static hasValue(key: string): boolean {
        return __cache.has(key);
    }

    public static deleteValue(key: string) {
        __cache.delete(key);
    }

    public static deleteValueReg(test: RegExp) {
        for (const key of __cache.keys()){
            if (test.test(key)) {
                __cache.delete(key);
            }
        };
    }

    public static clear() {
        __cache.clear();
    }
}
